import { Dialog, DialogContent, makeStyles, useTheme } from "@material-ui/core";
import React from "react";
import { DialogTitle, Transition } from "../../../../utils/DialogTitle";
import { EditarEvbi } from "../component/FormEditarEvbi";
const useStyles = makeStyles((theme) => ({
    title: {
        fontSize: '20px',
        backgroundColor: 'white',
        color: '#2196F3',
        padding: '16px',
        display: 'flex',
        justifyContent: 'Center',
        alignItems: 'center',
        fontWeight: 'bold'
    },
    closeIcon: {
        color: theme.palette.primary.main, // Usa el color primario del tema
    }
}));

export const ModalSttingsScale = ({ setopenMondal, isOpen, data, listDepartamentos, listMunicipio, handledMunicipios, reload }) => {
    const classes = useStyles();
    const theme = useTheme(); // Obtén el tema

    const primaryColor = theme.palette.primary.main;
    const handleClose = () => {
        setopenMondal(false)
        reload("",1,10)
    }
    const handleRedirect = (route) => {
        // History.push(route) 
        window.location.href = route
        setopenMondal(false)
        reload()
    }

    const inputStyles = {
        border: `1px solid ${primaryColor}`, // Usa el color primario del tema para el borde
        color: 'black',
        borderRadius:'10px'
    };
    return (
        <>
            <div>
                <Dialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={isOpen}
                    TransitionComponent={Transition}
                    keepMounted
                    style={{ maxHeight: "500%" }}
                    fullWidth={true}
                    maxWidth="sm"
                

                >
                    <DialogTitle id="customized-dialog-title" onClose={handleClose} className={classes.title} style={{color:primaryColor}}>
                        {/* {isEdit? `Editar configuraciones ${bascula}`: `Crear configuraciones ${bascula}`} */}
                        Editar Evbi {data.name}
                    </DialogTitle>
                    <DialogContent style={{ paddingBottom: '30px' }}>
                        <EditarEvbi
                            data={data}
                            clear={handleClose}
                            listDepartamentos={listDepartamentos}
                            listMunicipio={listMunicipio !== undefined ? listMunicipio : []}
                            handledMunicipios={handledMunicipios}
                            inputStyles={inputStyles}
                        />
                    </DialogContent>
                </Dialog>
            </div>
        </>
    );
}